// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__wa9DJ","infected":"Cards_infected__3pxgo","recovered":"Cards_recovered__1S4zN","deaths":"Cards_deaths__BilW1"};